import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { FeatureAccessService } from '../Services/feature-access.service';

@Injectable({
  providedIn: 'root'
})
export class FeatureAccessGuard implements CanActivate {
  constructor(private svc: FeatureAccessService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | boolean {
    const featureCode = route.data['feature'] as string;
    if (!featureCode) return true;

    // If access is already loaded, check page allowed
    if (this.svc.isLoaded) {
      return this.checkAccess(featureCode);
    }

    const projectId = localStorage.getItem('projectId');
    if (projectId) {
      // Load access asynchronously before determining route allowance
      return this.svc.loadProjectAccess(projectId).pipe(
        map(() => this.checkAccess(featureCode))
      );
    }

    // No projectId and not loaded, redirect to access-required
    this.router.navigate(['/access-required']);
    return false;
  }

  private checkAccess(featureCode: string): boolean {
    if (this.svc.isPageAllowed(featureCode)) {
      return true;
    }

    // DISABLED or HIDDEN - prevent route activation and redirect to access-required
    this.router.navigate(['/access-required']);
    return false;
  }
}
